import React from 'react';
import { FiFileText } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const TrailerHome = ({ token }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    const path = token ? `/trailer-form?allow=${token}` : '/trailer-form';
    navigate(path);
  };

  return (
    <div className="mt-10 bg-white shadow-lg rounded p-4 px-6 border-[1.5px] border-gray-100 flex flex-col justify-between">
      <div className="text-[12px] font-semibold text-left mb-6 uppercase leading-[1.2]">
        TRAILER INSPECTION FORM
      </div>

      <div className="flex justify-center">
        <button
          onClick={() => handleNavigate()}
          className="bg-black text-white text-sm px-6 py-1 w-full rounded flex items-center justify-center gap-2 transition"
        >
          <FiFileText className="text-md" />
          Fill out Form
        </button>
      </div>
    </div>
  );
};

export default TrailerHome;
